<template>
    <Sheet class="container">
        <span class="warning hidden-sm-and-down">WARNING!</span>
        <span class="warning sm hidden-md-and-up">WARNING!</span>
        <h1>403</h1>
        <h3>您的權限不足!!</h3>
        <div>
            請按此
            <el-button
                    type="warning"
                    style="margin: 0 2px;"
                    @click="logout"
            >
                重新登入
            </el-button>
        </div>
    </Sheet>
</template>

<script>
    import ExceptionMixin from './ExceptionMixin';

    export default {
        name: 'Forbidden',
        mixins:[ExceptionMixin],
    }
</script>

<style scoped>
    .container{
        text-align: center;
    }
    .container .warning{
        font-size: 4rem;
        font-weight: bolder;
        color: orange;
    }
    .container .warning.sm{
        font-size: 2rem;
    }
</style>